import { createValidOptions } from './createValidOptions';
import type { ProductVariantsFragment } from '~/lib/Shop/generated/schema';
import { isDefined } from '~/utils/guards/isDefined';

/**
 * Creates valid options depending on the current selection.
 * Valid options are determined based on the previous valid options.
 *
 * @param optionSelection
 * @param currentSelection
 * @param optionsHierarchy A sorted list which determines the order the current selection is checked on.
 */
export function findNextValidConfiguration(
  optionSelection: ProductVariantsFragment['variants'],
  currentSelection: Record<string, string> = {},
  optionsHierarchy: ReadonlyArray<string>
): Record<string, string> {
  const variants = optionSelection?.filter(isDefined);
  if (!variants) {
    return {};
  }

  const nextValidOptions: Record<string, string> = {};

  for (const code of optionsHierarchy) {
    const currentOptionUid = currentSelection[code];
    const validOptions = createValidOptions(
      optionSelection,
      nextValidOptions,
      optionsHierarchy
    );
    if (!currentOptionUid || !validOptions[code]?.includes(currentOptionUid)) {
      break;
    }

    nextValidOptions[code] = currentOptionUid;
  }

  return nextValidOptions;
}
